import { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import api from "../lib/api";
import LeadForm from "../components/LeadForm";

export default function Contact() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data.content)).catch(() => {});
  }, []);

  const phone = content?.phone || "(380) 800-6365";
  const email = content?.email || "info@crystallogistics.services";

  return (
    <div className="bg-[#0B132B]" data-testid="contact-page">
      <section className="py-16 lg:py-24 bg-[#0f1830] border-b border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono2 text-xs uppercase tracking-widest text-[#F97316] mb-3">Contact Us</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight leading-none" data-testid="contact-title">
            Get in Touch
          </h1>
          <p className="text-slate-400 mt-5 max-w-2xl text-sm sm:text-base leading-relaxed">
            Leave your details and our agent will reach out within 1–2 hours during business hours.
          </p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2 space-y-4">
          {[
            { icon: Phone, label: "Call Us", value: phone, href: `tel:${phone.replace(/[^+\d]/g, "")}`, tid: "contact-phone" },
            { icon: Mail, label: "Email", value: email, href: `mailto:${email}`, tid: "contact-email" },
            { icon: MapPin, label: "Coverage", value: content?.address || "Serving carriers nationwide, USA", tid: "contact-address" },
            { icon: Clock, label: "Response Time", value: "Within 1–2 business hours", tid: "contact-response" },
          ].map(({ icon: Icon, label, value, href, tid }) => (
            <div key={label} className="bg-[#131C38] border border-[#1E293B] rounded-lg p-5 flex items-center gap-4" data-testid={tid}>
              <div className="w-11 h-11 rounded-md bg-[#F97316]/10 border border-[#F97316]/25 flex items-center justify-center text-[#F97316] shrink-0">
                <Icon className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-0.5">{label}</div>
                {href ? (
                  <a href={href} className="text-sm font-semibold text-white hover:text-[#F97316] transition-colors break-all">{value}</a>
                ) : (
                  <div className="text-sm font-semibold text-white">{value}</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="lg:col-span-3 bg-[#131C38] border border-[#1E293B] rounded-lg p-7 sm:p-9">
          <LeadForm />
        </div>
      </div>
    </div>
  );
}
